import { Routes } from '../../../nav/routes'
import { numberToLocalString } from '../../../util/util'
import { refundHistoryParser } from './TableParser'

export const transactionDetailsParser = (data: any, txnType = Routes.TRANSACTIONS) => {
  const detailsObject = {
    ern: data?.ern ?? 'NA',
    id: data?.id ?? 'NA',
    details: {
      timestamp: data?.date?.length > 0 ? data?.date : 'NA',
      ern: data?.ern?.length > 0 ? data?.ern : 'NA',
      failureReason: data?.failureMessage?.length > 0 ? data?.failureMessage : 'NA',
      channel: data?.channel?.length > 0 ? data?.channel : 'NA',
      amount: numberToLocalString(data?.amount) ?? 'NA',
      rrn: data?.rrn?.length > 0 ? data?.rrn : 'NA',
      status: data?.status?.length > 0 ? data?.status : 'NA',
      currency: data?.payment?.cardCountryCode === '356' ? 'INR' : 'NA' ?? 'NA',
      originalTransactionId: data?.originalTransactionId?.length > 0 ? data?.originalTransactionId : 'NA',
      terminalId: data?.acquirerTerminal?.length > 0 ? data?.acquirerTerminal : 'NA',
    },
    paymentDetails: {
      paymentMode: data?.payment?.paymentMode?.length > 0 ? data?.payment?.paymentMode : 'NA',
      cardNumber: data?.payment?.accountNumber?.length > 0 ? data?.payment?.accountNumber : 'NA',
      bankRefNum: data?.bankRefNumber?.length > 0 ? data?.bankRefNumber : 'NA',
      paymentType: data?.payment?.paymentType?.length > 0 ? data?.payment?.paymentType : 'NA',
      customerName: data?.customer?.name?.length > 0 ? data?.customer?.name : 'NA',
      offerId: data?.payment?.offerId?.length > 0 ? data?.payment?.offerId : 'NA',
      udf1: data?.payment?.udf1?.length > 0 ? data?.payment?.udf1 : 'NA',
      udf2: data?.payment?.udf2?.length > 0 ? data?.payment?.udf2 : 'NA',
      udf3: data?.payment?.udf3?.length > 0 ? data?.payment?.udf3 : 'NA',
      udf4: data?.payment?.udf4?.length > 0 ? data?.payment?.udf4 : 'NA',
      udf5: data?.payment?.udf5?.length > 0 ? data?.payment?.udf5 : 'NA',
      settlementRefNumber: data?.payment?.settlementRefNumber?.length > 0 ? data?.payment?.settlementRefNumber : 'NA',
    },
    // settlementDetails: {
    //   settlementDate: data?.settlementDetails?.date?.length > 0 ? data?.settlementDetails?.date : 'NA',
    //   settlementRefNumber:
    //     data?.settlementDetails?.referenceNumber?.length > 0 ? data?.settlementDetails?.referenceNumber : 'NA',
    //   settlementStatus: data?.settlementDetails?.status?.length > 0 ? data?.settlementDetails?.status : 'NA',
    // },
    customerDetails: {
      id: data?.customer?.id?.length > 0 ? data?.customer?.id : 'NA',
      name: data?.customer?.name?.length > 0 ? data?.customer?.name : 'NA',
      mobileNumber: data?.customer?.mobileNumber?.length > 0 ? data?.customer?.mobileNumber : 'NA',
      email: data?.customer?.email?.length > 0 ? data?.customer?.email : 'NA',
      addressLine1: data?.customer?.address?.line1?.length > 0 ? data?.customer?.address?.line1 : 'NA',
      addressLine2: data?.customer?.address?.line2?.length > 0 ? data?.customer?.address?.line2 : 'NA',
      city: data?.customer?.address?.city?.length > 0 ? data?.customer?.address?.city : 'NA',
      state: data?.customer?.address?.state?.length > 0 ? data?.customer?.address?.state : 'NA',
      zipCode: data?.customer?.address?.pincode?.length > 0 ? data?.customer?.address?.pincode : 'NA',
    },
    refund: data?.refundHistory?.length > 0 ? refundHistoryParser(data) : [],
    isRefunded: data?.refund?.amount === data?.amount,
    isRefundValid: false,
    refundAmount: data?.refund?.amount,
    essStatus: data?.essStatus,
    essSettlementGrossAmount: data?.essSettlementGrossAmount,
    convenienceFee: {
      amount: `${'\u20B9'}${' '}${numberToLocalString(data?.convenienceFee?.amount)}`,
      originalTxnAmt: `${'\u20B9'}${' '}${numberToLocalString(data?.convenienceFee?.originalTxnAmt)}`,
      ugst: `${'\u20B9'}${' '}${numberToLocalString(data?.convenienceFee?.ugst)}`,
      igst: `${'\u20B9'}${' '}${numberToLocalString(data?.convenienceFee?.igst)}`,
      cgst: `${'\u20B9'}${' '}${numberToLocalString(data?.convenienceFee?.cgst)}`,
      sgst: `${'\u20B9'}${' '}${numberToLocalString(data?.convenienceFee?.sgst)}`,
    },
    splitTxns: data?.splitTxns?.map((item) => {
      return {
        amount: `₹ ${item.amount}`,
        initiatedDate: item.initiatedDate,
        beneficiaryName: item.beneficiaryName,
        status: item.status,
      }
    }),
  }

  const txnAmt = Number(detailsObject?.details?.amount)
  const refundAmt = Number(detailsObject?.refund?.amount)

  const getRefundValid = () => {
    const getValid = {
      [Routes.TRANSACTIONS]: detailsObject?.details?.status === 'SUCCESS' && txnAmt > refundAmt,
      [Routes.REFUNDS]: txnAmt > refundAmt,
    }
    return getValid[txnType] ?? false
  }
  const isRefundValid = getRefundValid()
  detailsObject.isRefundValid = isRefundValid
  return detailsObject
}
